export const state = () => ({
  layouts: [],
  types: []
});

export const getters = {
  layouts: state => state.layouts,
  types: state => state.types
}

export const mutations = {
  SET_QUESTION_LAYOUTS(state, layouts) {
    state.layouts = layouts
  },

  SET_QUESTION_TYPES(state, types) {
    state.types = types
  }
};
